/* GTM PIN-code check. No network calls: zones come from the shop metafield
   rendered into the page. Messages never promise a date the store hasn't set. */
if (!customElements.get('gtm-pin-check')) {
  class GtmPinCheck extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.gtm-pin__input');
      this.msg = this.querySelector('.gtm-pin__msg');
      try {
        this.zones = JSON.parse(this.querySelector('[data-zones]').textContent || '{}');
      } catch (e) {
        this.zones = {};
      }
      this.querySelector('.gtm-pin__btn').addEventListener('click', () => this.check());
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.check();
        }
      });
      let saved = null;
      try {
        saved = sessionStorage.getItem('gtm_pin');
      } catch (e) {}
      if (saved) {
        this.input.value = saved;
        this.check(true);
      }
    }

    zoneFor(pin) {
      const has = (list) => (list || []).some((p) => (p.length === 6 ? pin === p : pin.startsWith(p)));
      if (has(this.zones.dlf)) return 'dlf';
      if (has(this.zones.ncr)) return 'ncr';
      return 'india';
    }

    // dlf is inside ncr, which is inside india
    serves(productZones, pinZone) {
      const rank = { dlf: 0, ncr: 1, india: 2 };
      return productZones.some((z) => rank[pinZone] <= rank[z]);
    }

    check(quiet) {
      const pin = (this.input.value || '').trim();
      this.msg.className = 'gtm-pin__msg';
      if (!/^[1-9][0-9]{5}$/.test(pin)) {
        if (!quiet) {
          this.msg.textContent = 'Enter a 6-digit PIN code.';
          this.msg.classList.add('is-error');
        }
        return;
      }
      try {
        sessionStorage.setItem('gtm_pin', pin);
      } catch (e) {}
      const pinZone = this.zoneFor(pin);
      const productZones = (this.dataset.zone || 'india').split(',').map((z) => z.trim());
      const ok = this.serves(productZones, pinZone);
      const days = parseInt(this.dataset.dispatchDays, 10);
      const note = this.zones.placeholder ? ' (delivery areas not yet confirmed)' : '';
      if (ok) {
        let text;
        if (this.dataset.mode === 'weekly') text = 'Good news: you are in our first delivery area.';
        else if (pinZone === 'india') text = 'We deliver to ' + pin + '.';
        else text = 'We deliver to ' + pin + ' in our own van.';
        if (days > 0 && this.dataset.mode === 'product') text += ' Dispatches in ' + days + (days === 1 ? ' day.' : ' days.');
        this.msg.textContent = text + note;
        this.msg.classList.add('is-ok');
      } else {
        const wait = this.dataset.waitlistUrl;
        this.msg.innerHTML = '';
        const span = document.createElement('span');
        span.textContent =
          this.dataset.mode === 'weekly'
            ? 'We are not in ' + pin + ' yet. '
            : 'This item is delivered only in Delhi NCR, so we can’t send it to ' + pin + '. ';
        this.msg.appendChild(span);
        if (wait) {
          const a = document.createElement('a');
          a.href = wait;
          a.textContent = 'Join the waitlist';
          this.msg.appendChild(a);
        }
        if (note) this.msg.appendChild(document.createTextNode(note));
        this.msg.classList.add('is-error');
      }
      this.dispatchEvent(new CustomEvent('gtm:pin-checked', { bubbles: true, detail: { pin, pinZone, ok } }));
    }
  }
  customElements.define('gtm-pin-check', GtmPinCheck);
}
